import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres6de/mocker'

export default {
  getIndexTable (params) {
    if (isMock) return generator(mocker.IndaxTable(params))
    return instance().get(endpoint + '/hres6de')
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6de/index.js